import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  updateBarterCreditsForCollection,
  updateBarterLimitForAllCollections,
  updateBrandSourcingHistory,
  updateCreditLimits,
  updateCreditTriggers,
  updateSourcingBrandLimit,
  updateSourcingHistory,
  updateSourcingLimitForAllBrands,
} from "./creditsRedux";
import {
  useLazyGetBarterCreditLimitsForAllCollectionsQuery,
  useLazyGetBarterCreditsForCollectionQuery,
  useLazyGetBrandCreditLimitQuery,
  useLazyGetBrandSourcingCreditHistoryQuery,
  useLazyGetCreditLimitsForAllBrandsQuery,
  useLazyGetCreditLimitsQuery,
  useLazyGetSourcingCreditHistoryQuery,
} from "./creditsReduxAPI";
import useDataUpdate from "../../utils/useDataUpdate";

const CreditsDataLayer = () => {
  const dispatch = useDispatch();

  const [triggerGetCreditLimits, resultGetCreditLimits] =
    useLazyGetCreditLimitsQuery();
  const [triggerGetBrandLimit, resultGetBrandLimit] =
    useLazyGetBrandCreditLimitQuery();
  const [
    triggerGetCreditLimitsForAllBrands,
    resultGetCreditLimitsForAllBrands,
  ] = useLazyGetCreditLimitsForAllBrandsQuery();
  const [
    triggerGetBarterCreditLimitsForAllCollections,
    resultGetBarterCreditLimitsForAllCollections,
  ] = useLazyGetBarterCreditLimitsForAllCollectionsQuery();
  const [
    triggerGetBarterCreditsForCollection,
    resultGetBarterCreditsForCollection,
  ] = useLazyGetBarterCreditsForCollectionQuery();
  const [triggerSourcingCreditHistory, resultSourcingCreditHistory] =
    useLazyGetSourcingCreditHistoryQuery();
  const [triggerBrandSourcingCreditHistory, resultBrandSourcingCreditHistory] =
    useLazyGetBrandSourcingCreditHistoryQuery();

  const trigger = {
    getSourcingCreditLimits: async (apiCallParams) =>
      await triggerGetCreditLimits(apiCallParams),
    getSourcingBrandLimit: async (apiCallParams) =>
      await triggerGetBrandLimit(apiCallParams),
    getBarterCreditsForCollection: async (apiCallParams) =>
      await triggerGetBarterCreditsForCollection(apiCallParams),
    getSourcingCreditLimitsForAllBrands: async (apiCallParams) =>
      await triggerGetCreditLimitsForAllBrands(apiCallParams),
    getBarterCreditLimitsForAllCollections: async (apiCallParams) =>
      await triggerGetBarterCreditLimitsForAllCollections(apiCallParams),
    getSourcingCreditHistory: async (apiCallParams) =>
      await triggerSourcingCreditHistory(apiCallParams),
    getBrandSourcingCreditHistory: async (apiCallParams) =>
      await triggerBrandSourcingCreditHistory(apiCallParams),
  };

  useEffect(() => {
    dispatch(updateCreditTriggers(trigger));
  }, [trigger]);

  useDataUpdate(resultGetBrandLimit, updateSourcingBrandLimit);
  useDataUpdate(
    resultGetCreditLimitsForAllBrands,
    updateSourcingLimitForAllBrands
  );
  useDataUpdate(
    resultGetBarterCreditsForCollection,
    updateBarterCreditsForCollection
  );
  useDataUpdate(
    resultGetBarterCreditLimitsForAllCollections,
    updateBarterLimitForAllCollections
  );

  useEffect(() => {
    const data = resultGetCreditLimits.data;
    if (data?.success) {
      dispatch(updateCreditLimits(data));
    }
  }, [resultGetCreditLimits]);

  useEffect(() => {
    const data = resultGetBrandLimit.data;
    if (data?.success) {
      dispatch(updateSourcingBrandLimit(data.data));
    }
  }, [resultGetBrandLimit]);

  useEffect(() => {
    const data = resultSourcingCreditHistory.data;
    if (data?.success) {
      dispatch(updateSourcingHistory(data.data));
    }
  }, [resultSourcingCreditHistory]);

  useEffect(() => {
    const data = resultBrandSourcingCreditHistory.data;
    if (data?.success) {
      dispatch(updateBrandSourcingHistory(data.data));
    }
  }, [resultBrandSourcingCreditHistory]);

  return <></>;
};

export default CreditsDataLayer;
